// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_components.js'; import './autoload/_vendors.js'

// Import everything from modules
//import './modules/components'; import './modules/components/_clients-slider.js'; import './modules/components/_cube-rotating.js'; import './modules/components/_header.js'; import './modules/components/_hero.js'; import './modules/components/_seo-slider.js'; import './modules/components/_services-slider.js'; import './modules/components/_smooth-scroll.js'; import './modules/components/_testimonial.js'; import './modules/components/_widget-popup.js'; import './modules/forms'; import './modules/forms/comment_form.js'; import './modules/forms/contact_form.js'; import './modules/forms/form.js'; import './modules/forms/promotion_form.js'; import './modules/forms/subsidy_form.js'; import './modules/home.swiper.js'; import './modules/landing'; import './modules/landing/temperature-scanner-form.js'; import './modules/same_sized_cards.js'; import './modules/scrollable-swiper.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import temperatureScanner from './routes/landing/temperaturescanner';
import Utils from './util/utils';
import ENV from './env';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
    temperatureScanner,

});

// Load Events
jQuery(document).ready(() => {

    Utils.init();
    setTimeout(() => {
        routes.loadEvents();
        Utils.showLoader(false);
    }, ENV.DELAY_INIT);

});


// WEBPACK FOOTER //
// ./scripts/main.js